<template>
    <div>
        <v-progress-linear
        :active="cargando"
        :indeterminate="cargando"
        absolute
        location="top"
        color="deep-purple accent-4"
        ></v-progress-linear>

        <encabezado-filtros
            titulo="Membresías"
            :subtitulo="`${membresias.length} planes configurados`"
            v-model:busqueda="busqueda"
            placeholder-busqueda="Buscar membresía"
        >
            <template v-slot:acciones>
                <v-btn color="primary" @click="mostrarDialogo = true">
                    <v-icon start>mdi-plus</v-icon>
                    Nueva membresía
                </v-btn>
            </template>
        </encabezado-filtros>

        <v-card variant="outlined" rounded="lg">
        <v-data-table
        :headers="encabezadoTabla"
        :items="membresias"
        :search="busqueda"
        sort-by="nombre"
        :footer-props="{itemsPerPageText: 'Por página'}"
        >
        <template v-slot:item.precio="{ item }">
        {{ formatPrecio(item.precio) }}
    </template>
        <template v-slot:item.cant_entradas="{ item }">
        <span>{{ item.cant_entradas === 0 ? 'Todos los días' : item.cant_entradas }}</span>
    </template>

        <template v-slot:[`item.opciones`]="{ item }">
            <v-tooltip location="bottom" color="primary">
                <template v-slot:activator="{ props }">
                    <v-btn
                        icon="mdi-pencil"
                        color="primary"
                        size="small"
                        variant="text"
                        v-bind="props"
                        @click="editar(item)"
                    ></v-btn>
                </template>
                <span>Editar</span>
            </v-tooltip>
            <v-tooltip location="bottom" color="error">
                <template v-slot:activator="{ props }">
                    <v-btn
                        icon="mdi-delete"
                        color="error"
                        size="small"
                        variant="text"
                        v-bind="props"
                        @click="eliminar(item)"
                    ></v-btn>
                </template>
                <span>Eliminar</span>
            </v-tooltip>
        </template>
        </v-data-table>
        </v-card>

        <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3000"
        :color="mensaje.color"
        location="top"
        >
            {{ mensaje.texto }}
        </v-snackbar>

        <v-dialog
        v-model="mostrarDialogo"
        persistent
        max-width="600px"
        >
            <form-membresia @cerrado="onCerrado" @registrar="onRegistrar" :membresia="membresia" :titulo="titulo"/>
        </v-dialog>
        <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
            <dialogo-eliminar :nombre="itemSeleccionado" @cancelar="cerrarDialogoEliminar" @eliminar="confirmarEliminar"/>
        </v-dialog>
    </div>
</template>
<script>
import FormMembresia from './FormMembresia.vue'
import DialogoEliminar from '../Dialogos/DialogoEliminar.vue'
import HttpService from '../../Servicios/HttpService'
import EncabezadoFiltros from '../Dialogos/EncabezadoFiltros.vue'

export default {
    name: "Membresias",
    components: { FormMembresia, DialogoEliminar, EncabezadoFiltros },

    data: () => ({
        busqueda: "",
        cargando: false,
        mostrarDialogo: false,
        mostrarDialogoEliminar: false,
        membresia: {
            nombre: "",
            duracion: "",
            precio: ""
        },
        membresias: [],
        mensaje: {
            texto: "",
            color: ""
        },
        mostrarMensaje: false,
        encabezadoTabla: [
            {title: "Membresía", sortable: true, key: "nombre"},
            {title: "Duración", key: "duracion"},
            {title: "Cantidad de entradas", key: "cant_entradas"},
            {title: "Precio", key: "precio"},
            {title: 'Opciones', key: 'opciones', sortable: false },
            ],
        titulo: "Agregar",
        itemSeleccionado: ""
    }),

    mounted(){
        this.obtenerMembresias()
    },

    methods:{
      formatPrecio(precio) {
        if (!precio) return '$0';
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(precio);
    },
        editar(membresia){
            this.titulo = "Editar"
            this.membresia = membresia
            this.mostrarDialogo = true
        },

        eliminar(membresia){
            this.itemSeleccionado = membresia.nombre
            this.membresia = membresia
            this.mostrarDialogoEliminar = true
        },

        cerrarDialogoEliminar(){
            this.mostrarDialogoEliminar = false
            this.membresia = {
                nombre: "",
                duracion: "",
                precio: ""
            }
        },

        confirmarEliminar(){
            this.cargando = true
            let payload = {
                metodo: "delete",
                id: this.membresia.id
            }
            HttpService.eliminar("membresias.php", payload)
            .then(eliminado => {
                if(eliminado){
                    this.mostrarDialogoEliminar = false
                    this.mostrarMensaje = true
                    this.mensaje.texto = "Membresía eliminada"
                    this.mensaje.color = "success"
                    this.cargando = false
                    this.obtenerMembresias()
                }
            })
        },

        onCerrado(valor) {
            this.membresia = {
                nombre: "",
                duracion: "",
                precio: ""
            }
            this.mostrarDialogo = valor
            this.titulo = "Agregar"
        },

        onRegistrar(membresia) {
            let metodo = (this.titulo === "Agregar") ? "post" : "put"
            this.membresia = membresia
            this.cargando = true
            let payload = {
                metodo: metodo,
                membresia: this.membresia
            }
            HttpService.registrar(payload, "membresias.php")
            .then(respuesta => {
                if (respuesta){
                    this.membresia = {
                        nombre: "",
                        duracion: "",
                        precio: ""
                    }
                    this.mostrarDialogo = false
                    this.mostrarMensaje = true
                    this.mensaje.texto = "Membresía registrada"
                    this.mensaje.color = "success"
                    this.cargando = false
                    this.obtenerMembresias()
                    this.titulo = "Agregar"
                }

            })

        },

        obtenerMembresias(){
            this.cargando = true
            let payload = {metodo: "get"}
            HttpService.obtenerConDatos(payload, "membresias.php")
            .then(respuesta => {
                this.membresias = respuesta
                this.cargando = false
            })
        }
    }
}
</script>
